import React, { useState, useEffect } from 'react';
import Rater from 'react-rater';
import { shallowEqual, useSelector } from 'react-redux';
import { useRouteMatch, Link } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router-dom';
import { UploadChangeParam } from 'antd/lib/upload/interface';
import Configs from 'config';
import { get, map, filter } from 'lodash';
import { RootState } from 'modules';
import moment, { Moment } from 'moment';
import { BsFillBookmarkFill, BsClock } from 'react-icons/bs';
import { WordCount, checkWordCount } from 'components/base/WordCount';
import ClassScheduleModal, {
  toLocaleString,
  toLocaleStringLocal,
  getDateTimeFromSelectedTimeSlice,
} from 'components/mentoring/ClassScheduleModal';
import CreditPurchaseModal from 'components/mentoring/CreditPurchase';
import { ProfileWrapper } from 'components/mentoring/styles';
import MentoringRuleModal from 'components/modal/MentoringRuleModal';
import { showConfirm } from 'components/modal/showConfirm';
import { handleFieldError, moveToFirstError } from 'libs/api/errorHandle';
import {
  mentoringClassCreate,
  selectMentoringClassTopic,
  getMentoringClass,
  updateMentoringClass,
} from 'libs/api/mentoring';
import { getMentor, setInterestedMentor, getFormattedSchedules, getCreditBalance } from 'libs/api/user';
import { useDataApi } from 'libs/hooks';
import { useTimezone } from 'libs/hooks';
import { filteredFileNames } from 'libs/utils';
import { getUrlQuery } from 'libs/utils';
import { TMentoringClassCreate, TMentoringClassCreateForm, TSelectedTimeSlice } from 'modules/mentoring';
import { CURRENT_TICKET_BALANCE, CURRENT_FINANCE_TICKET_BALANCE } from 'modules/mentoring';
import { TMentoringClass } from 'modules/mentoring/types';
import { RouteMatch, TSelectList, TModalState } from 'modules/types';
import { TMentor, TFormattedSchedule } from 'modules/user';
import { CUploadFileProps, CWindowWidth, CDefaultDateTimeFormat } from 'constants/base.const';
import { CNumOfSlice, CNumOfOneHourSlice } from 'constants/mentoring.const';
import { ENotificationType } from 'enums/base.enum';
import { EMentoringField } from 'enums/mentoring.enum';
import { ERoute } from 'enums/route.enum';
import {
  Skeleton,
  Upload,
  Checkbox,
  Input,
  Button,
  Col,
  Row,
  Typography,
  Form,
  Divider,
  Spin,
  Tag,
  message,
} from 'antd';
import { CheckSquareOutlined, PlusSquareOutlined, CalendarOutlined, CheckOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { PrimaryColor, SecondaryColor, FormWrapper } from 'GlobalStyles';

const { Text, Title } = Typography;
const MentoringClassCreateWrapper = styled.div`
  color: #000;
  font-size: 16px;

  .form-normal .ant-form-item-label label {
    font-size: 17px !important;
  }
  .ant-form-item {
    margin-bottom: 50px;
  }
  .comment {
    color: ${PrimaryColor};
    font-size: 13px;
  }
  .form_textarea {
    resize: none;
  }
  .selected-tag {
    display: block;
    width: fit-content;
    margin: 3px 0px;
    padding: 0px 10px;
    border: 1px solid ${SecondaryColor};
    border-radius: 8px;
    color: ${PrimaryColor};
  }
`;

//멘토 선택해서 들어와서 -> 멘토링 신청 페이지
const MentoringClassCreate = () => {
  const [form] = Form.useForm();
  const match = useRouteMatch(`${ERoute.MentoringClassCreate}`);
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const { record_id } = (match?.params as RouteMatch) || {};
  const history = useHistory();
  const location = useLocation();
  const getPromise = getMentor.bind(null, record_id);
  const [{ data, loading }, setCallback] = useDataApi<TMentor>(getPromise);
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const [{ data: topics, loading: topicsLoading }] = useDataApi<TSelectList>(
    selectMentoringClassTopic.bind(null),
  );
  const [{ data: formattedSchedules, loading: formattedSchedulesLoading }] = useDataApi<
    Array<TFormattedSchedule>
  >(getFormattedSchedules.bind(null, record_id));
  const [classScheduleModal, setClassScheduleModal] = useState(false);
  const [selectedSchedules, setSelectedSchedules] = useState<Array<Moment>>([]);
  const [mentoringRuleModal, setMentoringRuleModal] = useState(false);
  const mentorTagColor = get(data, 'mentor_type') === 'senior' ? `${PrimaryColor}` : `${SecondaryColor}`;
  const [getDateTime, timezone] = useTimezone();
  const planIndex = get(data, 'is_senior') === true ? 1 : 0; /* 우선 가격은 senior, junior로만 구분 */
  const [creditPurchaseModal, setCreditPurchaseModal] = useState<TModalState>({
    record: '',
    visible: false,
  });
  const [numOfSlice, setNumOfSlice] = useState<number>(0);
  const { id } = getUrlQuery(location.search); //수업 자체의 아이디
  const [prevData, setPrevData] = useState<TMentoringClass>();
  const today = getDateTime('');
  // const [{ data: creditBalance }] = useDataApi<{ [key: string]: string }>(getCreditBalance.bind(null));
  //  쿼리 파라미터로 멘토의 필트 consulting, finance 구분해서 받는다면
  const getBalancePromise = getCreditBalance.bind(null, {
    field: {
      mentoring_field: data?.mentoring_field,
    },
  });
  //멘토 데이터 받아준 data 가 있어야만 api 실행될 수 는 조건 => data &&
  const [{ data: creditBalance }, setBalanceCallback] = useDataApi<{ [key: string]: string }>(
    data && getBalancePromise.bind(null),
  );
  //멘토 데이터인 data가 있을 때만 promise실행될 수 있게 => 파라미터에 data?.mentoring_field 값 담아야해서
  useEffect(() => {
    if (data) setBalanceCallback(() => getBalancePromise);
  }, [data]);

  // id => 수업 자체의 아이디
  // record_id => 멘토 아이디

  function onClickSubmit() {
    form
      .validateFields()
      .then((value) => {
        switch (get(data, 'mentoring_field')) {
          case EMentoringField.Consulting:
            handleSubmit(value as TMentoringClassCreateForm);

            break;
          case EMentoringField.Finance:
            handleSubmit(value as TMentoringClassCreateForm);

            // setCreditPurchaseModal({
            //   visible: true,
            //   onFinish: () => {
            //     handleSubmit(value as TMentoringClassCreateForm);
            //   },
            //   record: {
            //     planIndex: planIndex,
            //     count: selectedSchedules?.length,
            //   },
            // });
            break;
          case EMentoringField.Tech:
            handleSubmit(value as TMentoringClassCreateForm);

            // setCreditPurchaseModal({
            //   visible: true,
            //   onFinish: () => {
            //     handleSubmit(value as TMentoringClassCreateForm);
            //   },
            //   record: {
            //     planIndex: planIndex,
            //     count: selectedSchedules?.length,
            //   },
            // });
            break;
        }
      })
      .catch((errorInfo) => {
        moveToFirstError(form, errorInfo.errorFields);
      });
  }

  async function handleSetInterested(isInterested: boolean) {
    try {
      await setInterestedMentor({
        mentor_id: record_id,
        is_interested: isInterested,
      });
      setCallback(() => getPromise);
    } catch (e) {
      throw e;
    }
  }

  async function handleSubmit(value: TMentoringClassCreateForm) {
    try {
      const limitTime = moment(
        today
          .clone()
          .add(1, 'h')
          .format(CDefaultDateTimeFormat),
      );
      const selectedStartTimes = value.selected_schedules.map(
        (el: { start_at: string; end_at: string; mentor_id: number }) => moment(el.start_at),
      );
      const unavailableStartTimes = selectedStartTimes.filter((el: any) => el < limitTime);

      if (unavailableStartTimes.length > 0) {
        message.error('수업 시작이 1시간 이내로 남은 수업은 신청이 불가능합니다.');
      } else {
        setSubmitButtonDisabled(true);
        if (!!id) {
          const params = {
            file_ids: filteredFileNames(get(value, 'files')),
            desired_topic_ids: get(value, 'desired_topic_ids'),
            requirement: get(value, 'requirement'),
          };
          const res = await updateMentoringClass(Number(id), params);
        }

        if (!id) {
          const response = await mentoringClassCreate(
            map(form.getFieldValue('selected_schedules'), (schedule) => {
              //배열로 =>0: {start_at: "2021-08-20 01:00", end_at: "2021-08-20 02:00", mentor_id: "107"}
              return {
                file_ids: filteredFileNames(get(value, 'files')),
                mentor_id: get(schedule, 'mentor_id'),
                desired_topic_ids: get(value, 'desired_topic_ids'),
                requirement: get(value, 'requirement'),
                start_at: get(schedule, 'start_at'),
                end_at: get(schedule, 'end_at'),
              } as TMentoringClassCreate;
            }),
          );
        }

        history.push({
          pathname: ERoute.MentoringMyPage,
          state: {
            notification: {
              type: ENotificationType.Success,
              message: !!id
                ? '수정이 완료되었습니다.'
                : '신청을 완료했습니다. 멘토가 수락하면 예정된 날짜에 멘토링이 진행됩니다.',
            },
          },
        });
      }
    } catch (e) {
      handleFieldError(e, form);
      throw e;
    } finally {
      setSubmitButtonDisabled(false);
    }
  }

  const makeTimeSliceNum = (time: any) => {
    const splitTime = time.split('T');
    const mentoringTime = splitTime[1];
    const hour = Number(mentoringTime.split(':')[0]);
    const minute = Number(mentoringTime.split(':')[1]);

    //시+분(0or0.5)의 두 배 값이 되어야 하기 때문에
    //30분일 때는 +1 / 00분일 때는 +0
    return hour * 2 + minute / 30;
  };

  const getPrevClassInfo = async () => {
    const { data } = await getMentoringClass(Number(id));
    if (data) {
      const alreadySelectedTopic = data.desired_topics.map((topic: any) => topic.id);
      setPrevData(data);

      form.setFieldsValue({
        requirement: data.requirement,
        //이런식으로 데이터  request ==> desired_topic_ids: (5) [2, 4, 6, 11, 12]
        desired_topic_ids: alreadySelectedTopic,
        files: map(get(data, 'files'), (v) => ({
          uid: v.id,
          status: 'done',
          name: v.file_name,
        })),
      });
      //멘토링 수업 자세히보기 페이지에서 -> 수정하기 눌러서 들어온 멘토링페이지에서는 -> 시간이 여러개가 아닌 한 개의 타임만 들어오기 때문에 배열 임의지정
      setSelectedSchedules([
        getDateTimeFromSelectedTimeSlice(
          {
            time_slice: makeTimeSliceNum(data.start_at),
            date_at: data.start_at.split('T')[0],
          },
          timezone,
        ),
      ]);
    }
  };

  const makeCurrentTicketString = () => {
    let stringArray: Array<string> = [];
    if (creditBalance) {
      if (data?.mentoring_field === EMentoringField.Consulting) {
        CURRENT_TICKET_BALANCE?.forEach((el: { ticket_name: string; key_name: string }) => {
          //0 초과일 경우(수강권 있을 경우)에만 stringArray에 넣어준다
          Number(creditBalance[el.key_name]) > 0 &&
            stringArray.push(`${el.ticket_name} ${Number(creditBalance[el.key_name])}회`);
        });
      }

      if (data?.mentoring_field === EMentoringField.Finance) {
        CURRENT_FINANCE_TICKET_BALANCE?.forEach((el: { ticket_name: string; key_name: string }) => {
          //0 초과일 경우(수강권 있을 경우)에만 stringArray에 넣어준다
          Number(creditBalance[el.key_name]) > 0 &&
            stringArray.push(`${el.ticket_name} ${Number(creditBalance[el.key_name])}회`);
        });
      }

      if (stringArray.length < 1) {
        return '(보유한 수강권이 없습니다)';
      } else {
        //마지막 요소에는 콤마가 없도록
        const joinString = stringArray.join(', ');
        return joinString;
      }
    } else {
      return '(보유한 수강권이 없습니다)';
    }
  };

  useEffect(() => {
    //초기 작성이 아닌 글 수정의 경우 기존의 데이터 받아오는 함수
    if (id) {
      getPrevClassInfo();
    }
  }, []);

  useEffect(() => {
    if (selectedSchedules && selectedSchedules.length > 0) {
      form.setFields([
        {
          name: 'selected_schedules',
          value: map(selectedSchedules, (v) => {
            return {
              start_at: v.format(CDefaultDateTimeFormat),
              //내가 선택한 슬랏들 타임 보여줌 (((60분 수업씩)))
              end_at: v
                .clone()
                .add(30 * numOfSlice, 'minutes')
                .format(CDefaultDateTimeFormat),
              mentor_id: record_id,
            };
          }),
          validating: true,
          errors: undefined,
        },
      ]);
    } else {
      form.setFields([
        {
          name: 'selected_schedules',
          value: undefined,
        },
      ]);
    }
  }, [selectedSchedules]);

  useEffect(() => {
    if (data?.mentoring_field === EMentoringField.Consulting) {
      setNumOfSlice(CNumOfSlice); // 3
    } else {
      //멘토가 finance혹은 tech 멘토일 때
      setNumOfSlice(CNumOfOneHourSlice); // 2
    }
  }, [data]);

  return (
    <MentoringClassCreateWrapper>
      <Spin tip='loading...' spinning={loading} delay={1000}>
        <Row
          style={{
            maxWidth: `${CWindowWidth - 300}px`,
            margin: '20px auto',
            padding: '30px 10px',
          }}
          gutter={[32, 16]}
        >
          <Col
            xs={{ span: 24, order: 2 }}
            sm={{ span: 24, order: 2 }}
            md={{ span: 17, order: 1 }}
            lg={{ span: 17, order: 1 }}
            xl={{ span: 17, order: 1 }}
          >
            <Title level={2} style={{ marginBottom: '0px' }}>
              멘토링 신청
            </Title>
            <div style={{ fontSize: '13px', color: `${SecondaryColor}` }}>
              내 수강권 현황 : {makeCurrentTicketString()}
            </div>
            <FormWrapper>
              <Form form={form} layout='vertical' className='form-normal'>
                <Form.Item label='나의 희망일정'>
                  <Input.Group>
                    {get(data, 'mentoring_field') === EMentoringField.Consulting ? (
                      <div className='comment'>
                        <CheckSquareOutlined />
                        &nbsp;멘토링은 1시간 30분 내외 진행됩니다.
                      </div>
                    ) : (
                      <div className='comment'>
                        <CheckSquareOutlined />
                        &nbsp;멘토링은 1시간 내외 진행됩니다.
                      </div>
                    )}
                    <div className='comment' style={{ marginBottom: '20px' }}>
                      <CheckSquareOutlined />
                      &nbsp;취소 및 일정변경 규약&nbsp;
                      <span
                        style={{
                          cursor: 'pointer',
                          textDecoration: 'underline',
                        }}
                        onClick={() => {
                          setMentoringRuleModal(true);
                        }}
                      >
                        확인하기
                      </span>
                    </div>

                    {/* rules={[{required: true}]} 필수 선택 조건 */}
                    <Form.Item
                      name='selected_schedules'
                      className='form-item no-margin'
                      style={{ maxWidth: '400px' }}
                      rules={[{ required: true }]}
                    >
                      {!id && (
                        <div
                          style={{
                            width: '100%',
                            height: '32px',
                            cursor: 'pointer',
                            lineHeight: '32px',
                            padding: '0px 11px',
                            color: PrimaryColor,
                            fontSize: '13px',
                          }}
                          onClick={() => {
                            setClassScheduleModal(true);
                          }}
                        >
                          <CalendarOutlined />
                          &nbsp; <span style={{ color: '#aeaeae' }}>희망일정을 선택해주세요</span>
                        </div>
                      )}
                      {!!id && (
                        <div
                          style={{
                            width: '100%',
                            height: '32px',
                            cursor: !!id ? 'not-allowed' : 'pointer',
                            lineHeight: '32px',
                            padding: '0px 11px',
                            color: PrimaryColor,
                            fontSize: '13px',
                          }}
                          // onClick={()=> {message.error("현재 사용할 수 없는 기능입니다.")}}
                        >
                          <CalendarOutlined />
                          &nbsp; <span style={{ color: '#aeaeae' }}>희망일정을 선택해주세요</span>
                        </div>
                      )}
                    </Form.Item>

                    <div>
                      {selectedSchedules &&
                        map(selectedSchedules, (value: Moment) => {
                          const formattedTime = `${toLocaleStringLocal(value, timezone)} (${30 *
                            numOfSlice}분 수업)`;
                          //selectedSchedules상태값들의 시간데이터 포매팅 ==> 2021-08-21 토요일 오전 3시 30분 (60분 수업)

                          return (
                            //table에서 선택한 시간들 리스트 하늘색 태그로
                            <Tag
                              className='selected-tag'
                              style={{
                                cursor: !!id ? 'not-allowed' : 'pointer',
                              }}
                              onClose={() => {
                                if (!!id) {
                                  // message.error("현재 사용할 수 없는 기능입니다.");
                                }
                                if (!id) {
                                  //tag에서 X 누르면 컨펌창 뜨도록
                                  //첫번째 인자 (컨펌 창 확인누르면서 닫을 때 콜백함수) selectedSchedules에 있었던 일정 중에서 X누른것만 빼고 리턴
                                  showConfirm(
                                    () =>
                                      setSelectedSchedules(
                                        filter(selectedSchedules, (v) => {
                                          return v != value;
                                        }),
                                      ),
                                    <>
                                      <div>{formattedTime}</div>
                                      <div style={{ margin: '10px 0px' }}>
                                        <img
                                          alt='profile_image'
                                          className='small-thumbnail-img'
                                          src={get(data, 'user.profile_image.absolute_url')}
                                        />
                                        <span style={{ marginLeft: '5px' }}>
                                          {get(data, 'user.fullname')}
                                        </span>
                                      </div>
                                      <div>멘토링을 취소하시겠습니까?</div>
                                    </>,
                                  );
                                }
                              }}
                              closable
                              visible={true}
                            >
                              {formattedTime}
                            </Tag>
                          );
                        })}
                    </div>
                  </Input.Group>
                </Form.Item>

                {/* rules={[{required: true}]} 필수 선택 조건 */}
                <Form.Item name='desired_topic_ids' label='희망 토픽' rules={[{ required: true }]}>
                  <Checkbox.Group className='checkbox-btn'>
                    {map(topics, (v) => (
                      <Checkbox value={get(v, 'value')}>{get(v, 'label')}</Checkbox>
                    ))}
                  </Checkbox.Group>
                </Form.Item>
                <Form.Item label='추가 요청사항'>
                  <Input.Group>
                    <Form.Item name='requirement' className='form-item no-margin'>
                      <Input.TextArea
                        className='form_textarea'
                        placeholder='추가 요청사항을 적어주세요'
                        maxLength={300}
                        rows={8}
                        name='requirement'
                        onChange={checkWordCount}
                      />
                    </Form.Item>
                    <WordCount target='requirement' maxCount={300} />
                  </Input.Group>
                </Form.Item>
                <Form.Item
                  label='첨부파일'
                  name='files'
                  shouldUpdate={(prevValues, currentValues) => prevValues.files !== currentValues.files}
                  valuePropName='fileList'
                  getValueFromEvent={(e: UploadChangeParam) => (Array.isArray(e) ? e : e && e?.fileList)}
                >
                  <Upload.Dragger
                    name='file'
                    {...CUploadFileProps}
                    action={`${Configs.API_HOST}/mentoring/mentoring_class/file`}
                    multiple={true}
                    onChange={(info: UploadChangeParam) => {
                      const { status } = info.file;
                      if (status === 'done') {
                        message.success(`${info.file.name} 업로드에 성공했습니다.`);
                      } else if (status === 'error') {
                        message.error(`${info.file.name} 업로드에 실패했습니다.`);
                      }
                    }}
                  >
                    <p className='ant-upload-text' style={{ color: '#aeaeae' }}>
                      Resume 등 멘토 분에게 사전에 전달이 필요하거나 멘토링 시간에 논의가 필요한 자료를
                      올려주세요.
                    </p>
                    <p className='ant-upload-text' style={{ color: '#aeaeae' }}>
                      (파일을 드래그하거나 여기를 클릭해주세요)
                    </p>
                    <p className='ant-upload-plus'>
                      <PlusSquareOutlined />
                    </p>
                  </Upload.Dragger>
                </Form.Item>
                <Form.Item shouldUpdate={true} className='form-button'>
                  {() => (
                    <Button
                      type='primary'
                      size='large'
                      htmlType='submit'
                      loading={submitButtonDisabled}
                      onClick={onClickSubmit}
                    >
                      {!!id ? '완료' : '멘토링 신청'}
                    </Button>
                  )}
                </Form.Item>
              </Form>
            </FormWrapper>
          </Col>
          <Col
            xs={{ span: 24, order: 1 }}
            sm={{ span: 24, order: 1 }}
            md={{ span: 6, offset: 1 }}
            lg={{ span: 6, offset: 1 }}
            xl={{ span: 6, offset: 1 }}
            style={{ textAlign: 'center' }}
          >
            <ProfileWrapper style={{ maxWidth: '200px' }}>
              <Link to={`${ERoute.MentoringMentorView.replace(':record_id', String(record_id))}`}>
                <img alt='profile_image' src={get(data, 'user.profile_image.absolute_url')} />
              </Link>
              {get(data, 'is_current', null) != null && (
                <Tag className='user-type-tag' color={mentorTagColor}>
                  {get(data, 'mentor_type') === 'junior' ? '주니어' : '시니어'}
                </Tag>
              )}
              <div className='name'>{get(data, 'user.fullname')}</div>
              <div className='intro'>"{get(data, 'short_introduction')}"</div>
              <Rater interactive={false} rating={get(data, 'score_average')} />
              <div>
                <span className='score'>{get(data, 'score_average')}</span>
                <span className='num-of-rater'>&nbsp;({get(data, 'num_of_rater', 0)})</span>
              </div>
            </ProfileWrapper>
            {get(data, 'is_interested') === true ? (
              <Button
                onClick={handleSetInterested.bind(null, false)}
                style={{ width: '90%', marginTop: '10px' }}
                className='small-btn'
              >
                <CheckOutlined />
                찜완료
              </Button>
            ) : (
              <Button
                onClick={handleSetInterested.bind(null, true)}
                style={{ width: '90%', marginTop: '10px' }}
                className='small-btn'
              >
                <BsFillBookmarkFill size='12px' />
                &nbsp;찜하기
              </Button>
            )}
            <Divider />
            <div style={{ textAlign: 'left' }}>
              <p>
                <strong>{get(data, 'user.fullname')} 멘토링 가능 일정</strong>
              </p>
              {formattedSchedulesLoading === true ? (
                <Skeleton active title={false} paragraph={{ rows: 5 }} />
              ) : (
                <div>
                  {formattedSchedules &&
                    formattedSchedules.length > 0 &&
                    map(formattedSchedules?.slice(0, 5), (value) => (
                      <div style={{ marginBottom: '10px' }}>
                        <div>
                          <strong>{getDateTime(get(value, 'start_at')).format('D')}일</strong>
                        </div>
                        <div style={{ fontSize: '14px' }}>
                          <BsClock style={{ fontSize: '12px' }} />
                          &nbsp;
                          {toLocaleString(moment(get(value, 'start_at')), timezone)}
                          &nbsp;-&nbsp;
                          {toLocaleString(moment(get(value, 'end_at')), timezone)}
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>
            <Divider />
          </Col>
        </Row>
      </Spin>

      {!id && (
        <ClassScheduleModal
          numOfSlice={numOfSlice}
          mentor={data}
          visible={classScheduleModal}
          setVisible={setClassScheduleModal}
          selectedSchedules={selectedSchedules}
          onFinish={(data: Array<TSelectedTimeSlice>) => {
            // 모달 닫을 때 멘토링 시간 선택 모달에서 선택한 시간들로 selectedSchedules STATE 업데이트
            setSelectedSchedules(
              map(data, (elem: TSelectedTimeSlice) => {
                //time_slice 값은 시간*2
                //data ==> [{time_slice: "9", date_at: "2021-08-29"}, {...}]
                //elem ==> {time_slice: "9", date_at: "2021-08-29"}
                //리턴값 ==> Moment {_isAMomentObject: true, _i: "2021-08-29", _f: "YYYY-MM-DD", _l: "Asia/Seoul", _isUTC: false, …}
                // console.log("함수적용",getDateTimeFromSelectedTimeSlice(elem, timezone));
                //선택한 시간들에서 '시,분,초' 시간데이터 추출
                return getDateTimeFromSelectedTimeSlice(elem, timezone);
              }),
            );
          }}
        />
      )}
      <MentoringRuleModal visible={mentoringRuleModal} setVisible={setMentoringRuleModal} />
      <CreditPurchaseModal modalState={creditPurchaseModal} setModalState={setCreditPurchaseModal} />
    </MentoringClassCreateWrapper>
  );
};

export default MentoringClassCreate;
